// Output matches backend SLUG_REGEX `^[a-z0-9]+(?:-[a-z0-9]+)*$`. Returns
// '' for inputs that yield no usable characters; the form's zod min(1) catches that.
export function slugify(input: string, maxLen = 80): string {
  if (!input) return '';

  const base = input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // drop combining diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  if (base.length <= maxLen) return base;

  // Truncate at the last hyphen before maxLen to avoid breaking a word.
  const sliced = base.slice(0, maxLen);
  const lastHyphen = sliced.lastIndexOf('-');
  return lastHyphen > 0 ? sliced.slice(0, lastHyphen) : sliced;
}
